<template>
  <div class="wrap" style="margin-bottom:10px">
    <el-button v-if="!start" type="success" size="mini" class="btn-record-voice" :loading='isLoading' @click.prevent="startAudio">开始录音</el-button>
    <el-button v-if="start" type="danger" size="mini" class="btn-record-voice" :loading='isLoading' @click.prevent="startAudio">{{time}}</el-button>
  </div>
</template>
<script>
import { upLoadWAV,submitScore } from "@/api/projects";

// 引入recorder.js
import Recorder from "js-audio-recorder";

let recorder = new Recorder({
  sampleBits: 16, // 采样位数，支持 8 或 16，默认是16
  sampleRate: 16000, // 采样率，支持 11025、16000、22050、24000、44100、48000，根据浏览器默认值，我的chrome是48000
  numChannels: 1, // 声道，支持 1 或 2， 默认是1
});
let interval = null;
import { mapGetters } from "vuex";

export default {
  name: "recorderView",
  props: {
    memberId: null,
    projectId: null,
    isGetPermission: {
        type : Boolean,
        default : false
      }
  },
  data() {
    return {
      isLoading: false,
      time: "开始录音",
      num: 60, // 按住说话时间
      audioFileList: [], // 上传语音列表
      start: false,
    };
  },

  computed: {
    ...mapGetters(["terminalType"]),
  },

  methods: {
    // 清除定时器
    clearTimer() {
      if (interval) {
        clearInterval(interval);
      }
      this.num = 60;
      this.time = "开始录音";
    },

    startAudio() {
      this.isLoading = true
      if (!this.getPermissionFn()) return
      if (this.start) {
        this.mouseEnd();
      } else {
        this.mouseStart();
      }
    },

    getPermissionFn() {
      if (this.isGetPermission) {
        return true;
      } else {
        Recorder.getPermission().then(
          () => {
            window.console.log("给权限了");
            this.isGetPermission = true;
            this.$emit('changeIsGet')
            this.isLoading = false
            return true;
          },
          (error) => {
            this.isLoading = false
            this.isGetPermission = false;
            window.console.log(`${error.name} : ${error.message}`);
            return true;
          }
        );
      }
    },

    mouseStart() {
        let timeOut = setTimeout(()=>{
          clearTimeout(timeOut)
          this.start = true;
          recorder.start().then(() => {
          this.time = "结束（" + this.num + "秒）";
          this.isLoading = false
          interval = setInterval(() => {
            if (this.num <= 0) {
              this.mouseEnd();
            } else {
              this.num--;
              this.time = "结束（" + this.num + "秒）";
            }
          }, 1000);
        }).catch(()=>{
          this.isLoading = false
        })
      },200)
      
    },

    mouseEnd() {
      // 暂停录音
      this.start = false;
      recorder.stop();
      this.clearTimer();
      this.upLoadWAVFn();
    },

    submitThisMsg(src) {
      let data = {
        memberId: this.memberId,
        projectId: this.projectId,
        ossPathList: [src.split(
          "https://nice-work.oss-cn-beijing.aliyuncs.com/"
        )[1]]
      }
      submitScore(data)
        .then(() => {
          this.$emit("wav");
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
          
    },

    upLoadWAVFn() {
      var file = new File([recorder.getWAVBlob()], "wavfile.wav", {
        type: "audio/wav",
      });
      let formData = new FormData();
      formData.append("file", file);
      this.isLoading = true;
      upLoadWAV(formData)
        .then((res) => {
          this.submitThisMsg(res.data.template)
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style>
button i {
  font-size: 12px;
}
</style>